import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";


import KTAppHeaderMobile from "./components/mobile-components/app-header-mobile";
import KTGlobal from "./components/global";
import KTAppTopPublicity from "./components/app-top-publicity";
import AppHeader from "@/components/app-header";
import AppFooter from "components/app-footer";

import { renderRoutes } from "react-router-config";

import routes from "./router";
import { initGA, trackPageview } from "./ga";

const AppRoutes = ({ windowSize }) => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);

  return (
    <>
      <KTGlobal />
      <KTAppTopPublicity />
      {windowSize.width > 480 ? <AppHeader /> : <KTAppHeaderMobile />}
      {renderRoutes(routes)}
      {windowSize.width > 480 ? <AppFooter /> : null}
    </>
  );
};

export default AppRoutes;